<template>
  <q-layout view="hhh lpr lfr">
    <q-header>
      <q-toolbar class="bgFatureSistemas">
        <q-btn flat round dense icon="menu" @click="drawer = !drawer" />
        <q-toolbar-title class="title text-white text-h4">
          Tutoriais
        </q-toolbar-title>
      </q-toolbar>
    </q-header>

    <q-drawer
      v-model="drawer"
      :width="360"
      :breakpoint="500"
    >
      <div class="bgFatureSistemas full-height">
        <div>
          <q-img
            class="q-mb-lg"
            src="../../../assets/logo_completa_branca.png"
            width="150px"
          />
          <q-img
            class="q-mb-lg"
            src="../../../assets/logo_gestaosistema.png"
            width="250px"
          />
        </div>

        <div class="q-gutter-y-sm q-mt-md">
          <div v-for="menu in menus" :key="menu">
            <q-btn
              flat
              no-caps
              :icon="menu.icon"
              :label="menu.title"
              align="left"
              class="full-width text-bold text-subtitle1"
              text-color="white"
              @click="onTutorial(menu)"
            />
          </div>
        </div>
        <div class="q-mt-xl">
          <q-btn
            flat
            no-caps
            class="full-width text-bold text-subtitle1"
            icon="reply"
            label="Voltar tela Login"
            align="left"
            text-color="white"
            @click="this.$router.push('/')"
          />
        </div>
      </div>
    </q-drawer>

    <q-page-container>
      <div class="titleVideo q-my-md text-h5">
        {{ titleVideo }}
      </div>
      <div class="q-px-xl">
        <q-video
          :src="linkVideo"
          :ratio="16/9"
        />
      </div>

    </q-page-container>

  </q-layout>
</template>

<script>
export default {
  data() {
    return {
      drawer: true,
      menus: [
        { title: 'Acessando e Configurando',          icon: 'looks_one',  link: 'https://www.youtube-nocookie.com/embed/BFIF1fAGmss', description: 'Acessando o Sistema e Configurando'},
        { title: 'Vendas e Comprovantes',             icon: 'looks_two',  link: 'https://www.youtube-nocookie.com/embed/FNmPxQKo9Ok', description: 'Cadastro de Vendas e Geração de Comprovante'},
        { title: 'Pedidos e Redes Sociais',           icon: 'looks_3',    link: 'https://www.youtube-nocookie.com/embed/KC4Sdk9E24g', description: 'Cadastros de Pedidos e Redes Sociais'},
        { title: 'Estoque e Clientes',                icon: 'looks_4',    link: 'https://www.youtube-nocookie.com/embed/REkVnxwJrKQ', description: 'Controle de Estoque e Cadastro de Clientes'},
        { title: 'Despesas e Acervo Imagens',         icon: 'looks_5',    link: 'https://www.youtube-nocookie.com/embed/5VxsM086V4A', description: 'Cadastro de Despesas e Acervo de Imagens'},
        { title: 'Mini SIte de Vendas e Orçamentos',  icon: 'looks_6',    link: 'https://www.youtube-nocookie.com/embed/pjUbVhN5x0A', description: 'Mini Site de Vendas e Orçamentos'},
      ],
      titleVideo: 'Acessando o Sistema e Configurando',
      linkVideo: 'https://www.youtube-nocookie.com/embed/BFIF1fAGmss',
    }
  },
  methods: {
    onTutorial(menu) {
      this.titleVideo = menu.description
      this.linkVideo = menu.link

      this.drawer = false
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Pacifico&display=swap');

  .title {
    font-family: 'Pacifico';
  }
  .titleVideo {
    font-family: 'Pacifico';
    color: #fe5700;
  }
  .bgFatureSistemas {
    background-color: #fe5700;
  }
</style>